<div class="side-event-details w-full h-full p-6">
  <div class="flex mb-4 text-gray-600">
    <mat-icon (click)="back.emit()" matTooltip="close" class="cursor-pointer">chevron_right</mat-icon>
  </div>

  <ig-image [src]="place.cover?.source" cls="w-full rounded-2xl"></ig-image>

  <div class="text-2xl font-bold text-gray-700 my-6" [class.mb-3]="place.isChoice">{{place.name}}</div>

  <div *ngIf="place.isChoice&&frontendSettings$ | async as settings"
    class="w-1/2 py-2 mb-3 bg-gradient-to-b from-[#b04aea] to-[#773bf2] text-xs text-white text-center">
    <span class="text-xs">{{settings.customSettings.customEditorChoice.editorChoiceForPlace}}</span>
  </div>

  <div *ngIf="place.categoryText" class="flex gap-2 mb-6">
    <p>{{place.categoryText}}</p>
  </div>

  <div *ngIf="place.rating" class="pt-4">
    <p class="text-gray-700 font-semibold text-lg">Rating</p>
    <div class="flex items-center gap-2">
      <div class="text-gray-500 font-sm">{{place.rating}}</div>
      <ig-stars [rating]="place.rating"></ig-stars>
    </div>
  </div>

  <div *ngIf="place.priceRange" class="pt-4">
    <p class="text-gray-700 font-semibold text-lg mb-1">Price Level</p>
    <div class="text-gray-500 font-sm">{{place.priceRange}}</div>
  </div>

  <ng-container *ngIf="place.description">
    <div class="text-lg text-gray-700 font-lg mb-3 mt-6">Description</div>
    <div #description class="my-4 text-gray-600 max-h-48 overflow-hidden" [class.!max-h-fit]="isShowingMore"
      [innerHTML]="sanitizer.bypassSecurityTrustHtml(place.description || '(No Description)')">
    </div>
  </ng-container>
  <!-- <div *ngIf="isNeedScroll()||isShowingMore" class="mt-4 cursor-pointer text-center text-[#3476d2]"
    (click)="isShowingMore=!isShowingMore">show {{isShowingMore?'less':'more'}}</div> -->

  <div *ngIf="place.phone" class="mt-4">
    <div class="text-lg text-gray-700 font-bold mb-1">Phone</div>
    <div class="text-sm text-gray-600">{{place.phone}}</div>
  </div>

  <div class="mt-4 pb-12">
    <div class="text-lg text-gray-700 font-bold mb-1">Address</div>
    <div class="text-sm text-gray-600">{{place.address?.address}}</div>
  </div>

  <!-- <div class="mt-4 pb-12">
    <ig-google-place-reviews *ngIf="placeAdditionalData" [googleId]="place?.id"
          [reviews]="placeAdditionalData?.googleReviews||placeAdditionalData?.reviews"></ig-google-place-reviews>
  </div> -->
</div>